var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-4 pb-1 w-100 row" },
    [
      _c("icon-view", {
        staticClass: "col-12 icon",
        attrs: {
          icon: "far fa-times-circle",
          "icon-color": "#ff7058",
          "icon-size": "17px",
          title: "Cancelar Cuestionario"
        }
      }),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c(
            "validation-observer",
            { ref: "cancelFormValidator", staticClass: "col-12" },
            [
              _c("validation-provider", {
                staticClass: "row d-flex align-items-end pl-3",
                attrs: { name: "Comment", rules: "required" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function({ errors }) {
                      return [
                        _c("custom-input", {
                          staticClass: "m-0 mb-1 p-0 col-sm-12 col-md-11",
                          attrs: {
                            "custom-error-msg":
                              "La razón de cancelación es requerida.",
                            error: errors[0],
                            label: "Comentario:",
                            maxlength: "3000"
                          },
                          model: {
                            value: _vm.comment,
                            callback: function($$v) {
                              _vm.comment = $$v
                            },
                            expression: "comment"
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-sm-12 col-md-1 mb-1 mt-md-4 pt-md-2 align-self-start"
                          },
                          [
                            _c("action-button", {
                              staticClass: "btn-actions mx-1",
                              attrs: {
                                i: "fas fa-times-circle",
                                variant: "outline-danger"
                              },
                              on: { click: _vm.cancel }
                            }),
                            _c("action-button", {
                              staticClass: "mx-auto btn-actions mx-1",
                              attrs: { i: "fas fa-save", variant: "success" },
                              on: { click: _vm.save }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }